import { anyFilterOn, type MapFilters } from '../mapView'

export interface YearPickerProps {
  years: number[]
  filters: MapFilters
  onFilters: (next: MapFilters) => void
}

export const STRETCH_HINT =
  'Click a year to show only it. Shift-click another to show the years between.'

export const pickedSpanName = (filters: MapFilters) => {
  if (!anyFilterOn(filters)) return 'All years'
  if (filters.fromYear === filters.toYear) return String(filters.fromYear)
  return `${filters.fromYear} to ${filters.toYear}`
}
